import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request when the caller shows its own error message (for example the Cem-Base bulk scan,
 * which retries reads quietly). The server-error interceptor then skips its red toast but still
 * rethrows the error and still signs the user out on a 401.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/**
 * Set on a background request the user did not start (for example the Cem-Base server copy of a
 * draft, or a ticket photo thumbnail). The interceptors then leave the full-screen loader and the
 * "API call in progress" signal alone, so typing and tapping are never blocked by it.
 */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);
